import ComponentLoader from './ComponentLoader'

export default ComponentLoader
